import React, { forwardRef, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { printMissingConfigError, SiteConfigManager } from '@atlas/core';
import { HEADER_LAYOUT_TYPES, HeaderLayout } from '@atlas/ui';

import { PLATFORM_TYPES } from 'common/constants';
import DropdownLanguage from 'components/LanguageSwitcher';

import HeaderClock from './HeaderClock';
import HeaderInfo from './HeaderInfo';
import HeaderLogoItem from './HeaderLogoItem';
import { HeaderMenu } from './HeaderMenu';
import HeaderSettings from './HeaderSettings';
import HeaderSubmenuList from './HeadesSubmenuList';

const { DESKTOP, MULTIPLATFORM } = PLATFORM_TYPES;

const Header = ({ depositBtnLink, logoutRedirectLink, ref, withoutSubHeader }) => {
  const { pathname } = useLocation();

  const subpages = useMemo(() => {
    const topNavigation = SiteConfigManager.getConfig('navigation.top', []);

    if (topNavigation.length === 0) {
      printMissingConfigError('navigation.top');
    }

    const currentItem = topNavigation.find(item => {
      if (!item || !item.children) return;

      return item.children.find(subItem => pathname.startsWith(subItem.location));
    });

    return (
      currentItem?.children.filter(
        child => child.platform_type === MULTIPLATFORM || child.platform_type === DESKTOP,
      ) || []
    );
  }, [pathname]);

  const layout =
    SiteConfigManager.getConfig('config.config.general.desktopHeaderView') ||
    HEADER_LAYOUT_TYPES.HEADER1;
  const showHeaderClock =
    SiteConfigManager.getConfig('config.config.general.headerTimeVisibility') === 'show';

  const withSubpages = subpages.length > 0;
  const headerClassName = cx({ 'with-subtabs': withSubpages });

  return (
    <HeaderLayout className={headerClassName} ref={ref} type={layout}>
      <HeaderLayout.Logo>
        <HeaderLogoItem redirectTo="/" />
      </HeaderLayout.Logo>
      {!withoutSubHeader && (
        <>
          <HeaderLayout.Tabs>
            <HeaderMenu />
            {showHeaderClock && layout === HEADER_LAYOUT_TYPES.HEADER2 && <HeaderClock />}
          </HeaderLayout.Tabs>
          <HeaderLayout.Settings>
            <div className="header__box">
              <HeaderSettings className="header__settings" />
            </div>

            <div className="header__box">
              <DropdownLanguage className="header__lang dropdown-lang" />
            </div>

            {showHeaderClock && layout !== HEADER_LAYOUT_TYPES.HEADER2 && (
              <div className="header__box">
                <HeaderClock />
              </div>
            )}
          </HeaderLayout.Settings>
        </>
      )}
      <HeaderLayout.Content>
        <HeaderInfo depositBtnLink={depositBtnLink} logoutRedirectLink={logoutRedirectLink} />
      </HeaderLayout.Content>
      {!withoutSubHeader && (
        <HeaderLayout.SubTabs>
          {withSubpages && <HeaderSubmenuList subpages={subpages} />}
        </HeaderLayout.SubTabs>
      )}
    </HeaderLayout>
  );
};

Header.propTypes = {
  depositBtnLink: PropTypes.string,
  logoutRedirectLink: PropTypes.string,
  ref: PropTypes.func,
  withoutSubHeader: PropTypes.bool,
};

export default forwardRef(Header);
